import React from 'react'
import {style, media, merge} from 'glamor'
import * as colors from '../colors'

export default ({children, ...props}) => (
  <h2
    {...props}
    {...merge(
      style({
        display: 'inline-block',
        fontSize: '	1.5rem',
        fontWeight: 'normal',
        margin: '0 0 2rem',
        lineHeight: '1.2',
        padding: 0,
        borderBottom: `3px solid ${colors.yellow}`
      }),
      media('(min-width:800px)', {
        display: 'none'
      })
    )}
  >
    {children}
  </h2>
)



/** WEBPACK FOOTER **
 ** ./src/components/PageTitle.js
 **/